import moment from 'moment'

export default {
	messages: {
		methods: {
			apiMessagesSuggestions: function(thread) {
				return this.$http.post(this.uri + 'users_dev.suggestions');
			},
			apiMessagesThread: function(thread) {
				return this.$http.post(this.uri + 'messages.thread', { thread: thread });
			},
			apiMessageInbox: function() {
				return this.$http.post(this.uri + 'messages.inbox');
			},
			apiMessageSent: function() {
				return this.$http.post(this.uri + 'messages.sent');
			},
			apiMessageBetween: function(to) {
				return this.$http.post(this.uri + 'messages.between', { to });
			},
			apiMessagesThreads: function() {
				return this.$http.post(this.uri + 'messages.threads');
			},
			apiMessageSend: function(to, message) {
				return this.$http.post(this.uri + 'messages.send', { to, message }).then(function(data) {
					this.$root.$emit('envRefresh');
				}, function(data) {
					console.log(data.data);
					this.$bvToast.toast(data.data.error, {
						title: 'Errore',
						autoHideDelay: 5000,
					});
					throw new Error("Whoops!")
				});
			},
			messageManifest: function() {
				return {
					body: '',
					subject: ''
				}
			}
		}
	},
	adv: {
		methods: {
			apiAdvManifest: function() {
				return this.$http.post(this.uri + 'adv.manifest', { lang: this.$i18n.locale });
			}
		}
	},
	video: {
		methods: {
			apiVideoLive: function() {
				return this.$http.post(this.uri + 'video_live.live', { lang: this.$i18n.locale });
			},
			apiVideoGet: function(id) {
				return this.$http.post(this.uri + 'video.get', { id: id });
			}
		}
	},
	posts: {
		methods: {
			apiPostsStream: function() {
				return this.$http.post(this.uri + 'posts.stream');
			},
			apiPostsType: function(type, page) {
				return this.$http.post(this.uri + 'posts.GetsType', { type: type, page: page });
			},
			apiPostsGet: function(id) {
				return this.$http.post(this.uri + 'posts.get', { post_id: id });
			}
		}
	},
	offers: {
		methods: {
			apiPresets: function() {
				return this.$http.post(this.uri + 'offers.presets', { lang: this.$i18n.locale });
			},
			apiOffersPopular: function() {
				return this.$http.post(this.uri + 'offers.pop')
			},
			apiOffersGets: function(what, page = 0) {
				if(what == null || what == false) {
					var what = 'gets';
				}
				return this.$http.post(this.uri + 'offers.' + what, { page: page });
			},
			apiOffersGet: function(offer_id) {
				return this.$http.post(this.uri + 'offers.get', { offer_id });
			},
			apiOffersReview: function(payload) {
				return this.$http.post(this.uri + 'offers.review', { payload });
			},
			pendingNewOffers: function(id, bucket) {
				return _.filter(bucket, function(a) {
					return a.business_id == id && a.parent_id == 0;
				})
			},
			hasPendingReview: function(id, bucket) {
				return _.find(bucket, { parent_id: id });
			},
			offerManifest: function() {
				return {
					title: -1,
					title_en: -1,
					name: '',
					name_en: '',
					description: '',
					description_en: '',
					expire_date: moment().add('1', 'month').format('YYYY-MM-DD HH:mm:ss'),
				}
			}
		}
	},
	favorites: {
		methods: {
			apiFavoritesToggle: function(type, type_id) {
				return this.$http.post(this.uri + 'favorites.toggle', { type: type, type_id: type_id }).then(function(a) {
					this.$root.$emit('envRefresh');
				})
			},
			apiFavoritesGets: function() {
				return this.$http.post(this.uri + 'favorites.all');
			}
		}
	},
	users: {
		methods: {
			apiUserTranslate: function(text, from, to) {
				return this.$http.post(this.uri + 'translation.phrase', { text,from,to });
			},
			apiUserTranslatePhrases: function(phrases) {
				return this.$http.post(this.uri + 'translation.phrases', { phrases });
			},
			apiUserTranslateArray: function(arr, offers) {
				return this.$http.post(this.uri + 'translation.array', { arr, offers });
			},
			apiUserUpgrade: function(dt) {
				return this.$http.post(this.uri + 'users.upgrade', { data: dt });
			},
			apiUserLogin: function(user) {
				return this.$http.post(this.uri + 'users.authenticate', { data: user });
			},
			apiUserPortal: function(key) {
				return this.$http.post(this.uri + 'users.joinportal', { "join-key": key });
			},
			apiUserJoin: function(payload) {
				return this.$http.post(this.uri + 'users.join', payload);
			},
			apiUserSearch: function(username) {
				return this.$http.post(this.uri + 'users.publicsearch', { username: username });
			},
			apiUserRecovery: function(email) {
				return this.$http.post(this.uri + 'users.recovery', { email });
			},
			apiUserRecoveryPortal: function(hash) {
				return this.$http.post(this.uri + 'users.recoveryportal', { hash });
			},
			apiUserRecoveryPassword: function(hash, check, user) {
				return this.$http.post(this.uri + 'users.recoverypassword', { hash, check, user });
			},
			apiUserUpdateGuard: function(infos) {
				return this.$http.post(this.uri + 'users.updateguard', { user: infos })
			},
			apiUserUpdate: function(infos) {
				return this.$http.post(this.uri + 'users.update', infos)
			},
			apiUserPassword: function(infos) {
				return this.$http.post(this.uri + 'users.update_password', { data: infos} )
			},
			apiPrivacyPolicy: function() {
				return this.$http.post(this.uri + 'index.policies', { lang: this.$i18n.locale } )
			},
			apiCookiePolicy: function() {
				return this.$http.post(this.uri + 'index.policies', { lang: this.$i18n.locale } )
			},
			apiTerminiPolicy: function() {
				return this.$http.post(this.uri + 'index.policies', { lang: this.$i18n.locale } )
			}
		}
	},
	categories: {
		methods: {
			apiCategoriesGets: function() {
				return this.$http.post(this.uri + 'categories.gets', { contexts: [ 'CompaniesAmount' ] });
			},
			apiCategoriesGet: function(category_id, contexts) {
				return this.$http.post(this.uri + 'categories.get', { category_id: category_id, contexts });
			}
		}
	},
	businesses: {
		methods: {
			apiCompanyNewest: function(amount) {
				return this.$http.post(this.uri + 'businesses.newest', { amount });
			},
			apiCompanyOffers: function(amount) {
				return this.$http.post(this.uri + 'businesses.offers', { amount });
			},
			apiCompanySearch: function(query) {
				return this.$http.post(this.uri + 'businesses.search', { query });
			},
			apiCompanyGet: function(business_id, contexts) {
				return this.$http.post(this.uri + 'businesses.get', { business_id: business_id, contexts });
			},
			apiCompanyReview: function(business_id, detail) {
				return this.$http.post(this.uri + 'businesses.review', { business_id: business_id, detail: detail });
			},
			manifestReview: function(a) {

				var b = _.cloneDeep(a);

				return {
					logo: (b ? b.logo : ''),
					name: (b ? b.name : ''),
					category_id: ( b ? b.category_id : 0 ),
					company_profile: ( b ? b.company_profile : 0 ),
					about: ( b ? b.about : '' ),
					website: ( b ? b.website : '' ),
					phone: ( b ? b.phone : '' ),
					gyu_services: ( b ? b.gyu_services : '' ),
					gyu_offers: ( b ? b.gyu_offers : '' ),
					contact_name: ( b ? b.contact_name : '' ),
					contact_surname: ( b ? b.contact_surname : '' ),
					contact_role: ( b ? b.contact_role : '' ),
					contact_email: ( b ? b.contact_email : '' ),
					contact_phone: ( b ? b.contact_phone : '' ),
					contact_photo: ( b ? b.contact_photo : '' ),
				};
			}
		}
	}
}